<template>
  <div class="d-flex page-header mbm-3 justify-content-between">
    <div>{{ headerName }}</div>
    <div class="d-flex end-0">
      <div>{{ headerContent }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageHeader',
  props: {
    headerName: String,
    headerContent: String
  }
}
</script>

<style scoped lang="scss"></style>
